/* src/app/shared/components/form-controls/ag-text-switch/ag-text-switch.component.scss */
.switch-container {
  display: flex;
  width: 100%;
}
.button {
  border-radius: 8px !important;
  height: 36px;
  font-size: 13px;
  font-weight: normal;
  color: #333;
  background: #fff;
  border: solid 1px #333;
  white-space: nowrap;
  box-shadow: none;
  text-align: center;
  transition: 0.3s;
  width: 50%;
  min-width: 50px;
  margin-right: 8px;
  padding: 0 15px;
}
.button.round-left {
  border-top-left-radius: 18px !important;
  border-bottom-left-radius: 18px !important;
}
.button.round-right {
  border-top-right-radius: 18px !important;
  border-bottom-right-radius: 18px !important;
}
.button.smalltoggle {
  height: 28px;
  object-fit: contain;
  font-size: 12px;
  align-self: center;
}
.button.smalltoggle.round-right {
  border-top-right-radius: 14px !important;
  border-bottom-right-radius: 14px !important;
}
.button.smalltoggle.round-left {
  border-top-left-radius: 14px !important;
  border-bottom-left-radius: 14px !important;
}
.button.checked {
  background-color: #61566e;
  color: #f2eee7;
  box-shadow: 0 1px 3px 0 rgba(140, 140, 140, 0.75);
  border: solid 1px #61566e;
  font-weight: bold;
}
.button.checked.green {
  background-color: #578a6b;
  border: solid 1px #578a6b;
}
.button.checked.red {
  background-color: #d7263c;
  border: solid 1px #d7263c;
}
.button:hover {
  opacity: 0.9;
}
/*# sourceMappingURL=ag-text-switch.component.css.map */
